import { render, staticRenderFns } from "./Arcade.vue?vue&type=template&id=84ee422a&scoped=true&"
import script from "./Arcade.vue?vue&type=script&lang=ts&"
export * from "./Arcade.vue?vue&type=script&lang=ts&"
import style0 from "./Arcade.vue?vue&type=style&index=0&id=84ee422a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ee422a",
  null
  
)

export default component.exports